import { MandateSource } from '../repayments/nach/contracts/nach';

export class Application {
    ApplicationId: string;
    ApprovedUrl: string;
    BasketAmount: number;
    BasketItems: BasketItems[];
    CreatedOn: string;
    CustomerId: string;
    CustomerRank: null;
    CashbackType: number;
    DownpaymentAmount: number;
    DownpaymentRate: string;
    Flow: number;
    InitialPaymentAmount: number;
    InterestAmount: number;
    InterestFreeMonths: number;
    InterestRate: number;
    IsCODOnly: boolean;
    IsCODEnabled: boolean;
    IsDPMade: boolean;
    IsDownpaymentProvidedByMerchant: boolean;
    MambuLoanId: string;
    PaymentGatewayName: string;
    PaymentGatewayId: string;
    IsRiskApproved: boolean;
    IsRiskDeclined: boolean;
    LoanAmount: number;
    MerchantId: string;
    MerchantName: string;
    GenericMerchantId: string;
    GenericMerchantName: string;
    MerchantOrderId: string;
    NumberOfInstallments: number;
    ProcessingFee: number;
    ProcessingFeeRate: number;
    ReturnUrl: string;
    MerchantUrl: string;
    Status: number;
    TotalInstallmentAmount: number;
    PaymentMode: string;
    ShowKycUnderLimitByDefault: boolean;
    IsExtendedApiMerchant: boolean;
    IsVoucherMerchant: boolean;
    IsMerchantRiskEnabled: boolean;
    IsMerchantCustomerLogin: boolean;
    StatusPollingIntervalInSeconds: number;
    StatusPollingTimeInMinutes: number;
}
export class BasketItems {
    Category: string;
    Description: string;
    MerchantItemId: string;
    Quantity: number;
    TotalPrice: number;
}
export class MerchantDetails {
    MerchantItemId: string;
    Description: string;
}
export class MambuLoan {
    LoanApplicationId: string;
    MambuLoanEncodedKey: string;
    MambuLoanId: string;
}
export class RecommendedAndOtherEMIPlans {
    BasketAmount: number;
    OtherEmiOptions: EmiOption[];
    RecommendedEmiOptions: EmiOption[];
}
export class EmiOption {
    IsDefault: boolean;
    NumberOfMonths: number;
    TotalMonthlyAmount: number;
    InterestAmount: number;
    InterestFreeMonths: number;
    LoanAmount: number;
    DownpaymentAmount: number;
    ProcessingFee: number;
    ProcessingFeeRate: number;
    DownpaymentRate: number;
    InterestRate: number;
    SubventionInterestCashback: boolean;
    EffectiveEmiAmount: number;
}

export class LoanStates {
    CurrentStatus: number;
    AreDocumentsUploaded: boolean;
    IsBankAccountDetailsComplete: boolean;
    IsDownpaymentComplete: boolean;
    IsLoanAgreementAccepted: boolean;
    IsPoaUploaded: boolean;
    IsPoiUploaded: boolean;
    IsPreAccepted: boolean;
    IsRiskAccepted: boolean;
    IsRiskRefered: boolean;
    IsRiskDeclined: boolean;
    loanApplicationStatus: string;
    ProofOfIncomeMethodSelected: number;
    ProvidedBankStatementType: string;
    IsMandateCompleted: boolean;
    MandateSource: MandateSource;
    RequiredPerfios: boolean;
    IsTenureChanged: boolean;
    IsTenureChangeAccepted: boolean;
    IsLoanAmountChanged: boolean;
    IsLoanAmountChangeAccepted: boolean;
    IsMandateCollectedOffline: boolean;
    IsPDCompleted: boolean;
    IsEDCompleted: boolean;
    RejectionCode: string;
    RequiredBankDetails: boolean;
    KycFlowCompleted: boolean;
    vedantuDashboard: boolean;
}
export class CustomerStates {
    riskStage2Status: string;
    riskStage1Status: boolean;
    perfiosCompleted: boolean;
    mobilePhoneVerified: boolean;
    emailAddressVerified: boolean;
    ekycCompleted: boolean;
    bankDetailSubmitted: boolean;
    creditLimitActive: boolean;
    creditLimitExpiryDate: number;
    proofOfAddressUpload: boolean;
    proofOfIdUploaded: boolean;
    proofOfIncomeMethod: string;
    skipAadharVerificationClicked: boolean;
    isMandateCompleted: boolean;
    sourceMerchantId: string;
    merchantId: string;
    photoUploaded: boolean;
    isMandateCollectedOffline: boolean;
    isPDCompleted: boolean;
    isEDCompleted: boolean;
    requiredPerfios: boolean;
    customerId: string;
    customerType: string;
    customCLMerchantId: string;
    customCreditLimitAllowed: boolean;
    zestPersonalLoanAllowed: boolean;
    rejectionCode: string;
    relationDetailsAddedOn: boolean;
    kycFlow: string;
    kycStatus: string;
    kycFlowCompleted: boolean;
    kycInReview: boolean;

}
export class MerchantData {
    fullName: string;
    mobileNumber: string;
    emailAddress: string;
    addressLine1: string;
    addressLine2: string;
    pinCode: string;
    city: string;
}
export class States {
    customer: CustomerStates;
    loan: LoanStates;
}

export enum AcquisitionSource {
    Merchant = <any>'Merchant',
    Advertisement = <any>'Advertisement',
    Affiliate = <any>'Affiliate',
    Other = <any>'Other'
}

export class AcquisitionChannelData {
    customerId: string;
    affiliateId: string;
    acquisitionSource: AcquisitionSource;
    acquisitionChannel: string;
    applicationId: string;
    concurrency: boolean;
}

export class DeviceData {
    CustomerId: string;
    DeviceType: string;
    DeviceName: string;
    DeviceModel: string;
    DeviceOS: string;
    ApplicationId: string;
    BrowserVersion: string;
    UserAgent: string;
    constructor(CustomerId, DeviceType, DeviceName, DeviceModel, DeviceOS, ApplicationId, BrowserVersion, UserAgent) {
        this.CustomerId = CustomerId;
        this.DeviceType = DeviceType;
        this.DeviceName = DeviceName;
        this.DeviceModel = DeviceModel;
        this.DeviceOS = DeviceOS;
        this.ApplicationId = ApplicationId;
        this.BrowserVersion = BrowserVersion;
        this.UserAgent = UserAgent;
    }
}

export class MerchantConfig {
    merchantId: string;
    merchantName: string;
    netbankingOrEkyc: boolean;
    ekycOnly: boolean;
    showLogoInHeader: boolean;
    copyChanges: any;
    isdrivenUI: boolean;
    netbankingOnly: boolean;
    skipMandatePage: boolean;
    extendedMerchant: boolean;
    cashCreditEnabled: boolean;
    imageAllowedOnPerfios: boolean;
    onlyUploadStatement: boolean;
    allowKYCPhotoUpload: boolean;
    offlineGC: boolean;
    preventMyAccountRedirect: boolean;
    disableOtherGCMerchants: boolean;
    constructor() {
        this.merchantId = '';
        this.merchantName = '';
        this.netbankingOrEkyc = null;
        this.showLogoInHeader = null;
        this.ekycOnly = null;
        this.copyChanges = '';
        this.isdrivenUI = null;
        this.extendedMerchant = null;
        this.skipMandatePage = null;
        this.netbankingOnly = null;
        this.cashCreditEnabled = null;
        this.imageAllowedOnPerfios = false;
        this.onlyUploadStatement = false;
        this.allowKYCPhotoUpload = false;
        this.offlineGC = null;
        this.preventMyAccountRedirect = false;
        this.disableOtherGCMerchants = false;
    }
}

export enum GiftCardGenerationStatus {
    SUCCESS = <any>'SUCCESS',
    FAILURE = <any>'FAILURE',
    PARTIAL_FAILURE = <any>'PARTIAL_FAILURE',
    PENDING = <any>'PENDING'
}

export class GiftCardDetails {
    voucherCode: string;
    voucherPin: string;
    voucherValue: number;
    voucherValidity: number;
    merchantName: string;
    errorSegment: GiftCardDetailsErrorSegment;
}

export class GiftCardDetailsErrorSegment {
    result: GiftCardGenerationStatus;
    ErrorMessage: string;
}

export class GiftCardVouchers {
    disableCopy: false;
    giftCardDetails: GiftCardDetails[];
    giftCardGenerationStatus: GiftCardGenerationStatus;
}

export class GCToken {
    token: string;
}

export class ActiveApplication {
    Created: string;
    ExternalId: string;
    Flow: number;
    IsExtendedApiMerchant: boolean;
    LoanAmount: number;
    EmiAmount: number;
    NumberOfMonths: number;
    LoanStatus: string;
    MerchantId: string;
    MerchantName: string;
    Status: string;
    IsVoucherMerchant: boolean;
    ApprovedUrl: string;
    ReturnUrl: string;
    VoucherSelected: boolean;
    GenericMerchantId: string;
    GenericMerchantName: string;
}

export enum CancellationReasons {
    CustomerGotBackToMerchant = <any>'CustomerGotBackToMerchant',
    CustomerDroppedOff = <any>'CustomerDroppedOff',
    DuplicateApplication = <any>'DuplicateApplication',
    ItemOutOfStock = <any>'ItemOutOfStock',
    Withdrawn = <any>'Withdrawn',
    ApplicationBelowCreditLimit = <any>'ApplicationBelowCreditLimit',
    EmiChangeNotAcceptable = <any>'EmiChangeNotAcceptable',
    ProductPriceChanged = <any>'ProductPriceChanged',
    CustomerChangedHisMind = <any>'CustomerChangedHisMind',
    BadExperience = <any>'BadExperience',
    Other = <any>'Other'
}

export interface MerchantBannerConfig {
    merchantName: string;
    displayName: string;
    url: string;
    bannerList: string[];
    genericBanner: string;
}
